import angular from 'angular';
import { Estabelecimento } from '../../../../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../../../../shared/services/listagem.service';
import { ApuracoesPontoService } from '../../../../ApuracoesPonto/apuracoesponto.service';
import { IApuracaoPonto } from '../../../../models/apuracaoponto.model';
import {
    IGeracaoDeMarcacoesPadraoForm,
    IGeracaoDeMarcacoesPadraoTrabalhadorSelecionado
} from '../../models/geracao-de-marcacoes-padrao.form.model';
import {
    IApuracaoScope,
    ISelecaoDeColaboradoresUiState,
    OrigemSincronizacaoEstabelecimentoType
} from './models/selecao-de-colaboradores.form.model';

export class SelecaoDeColaboradoresFormController {

    static $inject = [
        '$scope',
        '$rootScope',
        'ListagemService',
        'ApuracoesPontoService',
    ];

    public form: angular.IFormController;
    public editable = false;
    public entity: IGeracaoDeMarcacoesPadraoForm;

    public estabelecimentos: Estabelecimento[] = [];
    public apuracaoSelecionada: IApuracaoPonto | null = null;
    public apuracaoScope: IApuracaoScope = this.createEmptyScope();
    public uiState: ISelecaoDeColaboradoresUiState = this.createUiState();
    public busy = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            session: any,
        },
        public ListagemService: ListagemService,
        public ApuracoesPontoService: ApuracoesPontoService,
    ) {
        this.$scope.$on('apuracoesponto_index_loaded', () => {
            this.handleContextChange();
        });
    }

    // lifecycle e contexto

    $onInit() {
        this.initializeEntity();
        this.initializeUiState();
        this.carregaEstabelecimentos();
        this.handleContextChange(false);
        this.setupWatchers();
    }

    setupWatchers() {
        this.observeContextChange(() => this.entity?.empresa, true);
        this.observeContextChange(() => this.entity?.apuracaoponto, false);
        this.observeEstabelecimento();
        this.observeDepartamento();
        this.observeLotacao();
        this.observeGrupoPonto();
        this.observeTrabalhador();
    }

    observeContextChange(selector: () => string, reloadEstabelecimentos: boolean) {
        this.$scope.$watch(selector, (newValue?: string, oldValue?: string) => {
            if (newValue === oldValue) {
                return;
            }

            this.handleContextChange(reloadEstabelecimentos);
        });
    }

    handleContextChange(reloadEstabelecimentos: boolean = true) {
        if (reloadEstabelecimentos) {
            this.carregaEstabelecimentos();
        }

        this.sincronizaApuracaoSelecionada();
        this.apuracaoScope = this.resolveApuracaoScope(this.apuracaoSelecionada);

        this.resetFiltroState();
        this.resetTrabalhadorState();
        this.applyFiltroScope(this.apuracaoScope);
        this.applyTrabalhadorScope(this.apuracaoScope);
        this.syncAllPayloads();
        this.refreshAllDependentSelects();
    }

    initializeEntity() {
        this.entity = this.entity || {} as IGeracaoDeMarcacoesPadraoForm;
        this.entity.aba_selecao_colaboradores = this.entity.aba_selecao_colaboradores || 1;
        this.entity.trabalhadores = this.entity.trabalhadores || [];
        this.entity.estabelecimento = this.entity.estabelecimento || '';
        this.entity.departamento_colaboradores = this.entity.departamento_colaboradores || null;
        this.entity.lotacao_colaboradores = this.entity.lotacao_colaboradores || null;
        this.entity.grupo_colaboradores = this.entity.grupo_colaboradores || null;
        this.entity.estabelecimento_selecionado_ui = this.entity.estabelecimento_selecionado_ui || null;
        this.entity.departamento_colaboradores_selecionado_ui = this.entity.departamento_colaboradores_selecionado_ui || null;
        this.entity.lotacao_colaboradores_selecionada_ui = this.entity.lotacao_colaboradores_selecionada_ui || null;
        this.entity.grupo_colaboradores_selecionado_ui = this.entity.grupo_colaboradores_selecionado_ui || null;
        this.entity.trabalhador_selecionado_ui = this.entity.trabalhador_selecionado_ui || null;
        this.entity.trabalhadores_selecionados_ui = this.entity.trabalhadores_selecionados_ui || [];
    }

    initializeUiState() {
        this.uiState = this.createUiState();
        this.uiState.trabalhador.lista = angular.copy(this.entity.trabalhadores_selecionados_ui || []);
        this.uiState.trabalhador.selecionado = angular.copy(this.entity.trabalhador_selecionado_ui || null);
    }

    createUiState(): ISelecaoDeColaboradoresUiState {
        return {
            filtro: {
                departamentoSelecionado: null,
                lotacaoSelecionada: null,
                grupoPontoSelecionado: null,
            },
            trabalhador: {
                selecionado: null,
                lista: [],
            },
            locks: {
                estabelecimento: false,
                lotacao: false,
                trabalhadores: false,
            },
            tabs: {
                disableFiltro: false,
            },
            sincronizacao: {
                origemEstabelecimento: null,
            },
        };
    }

    createEmptyScope(): IApuracaoScope {
        return {
            tipo: 'nenhum',
            empresa: '',
            estabelecimento: '',
            lotacao: null,
            trabalhador: null,
            locks: {
                estabelecimento: false,
                lotacao: false,
                trabalhadores: false,
            },
            forcaAbaTrabalhador: false,
        };
    }

    sincronizaApuracaoSelecionada() {
        this.apuracaoSelecionada = this.ApuracoesPontoService.entities.find((apuracao) => (
            apuracao.apuracaoponto === this.entity.apuracaoponto
        )) || null;
    }

    resolveApuracaoScope(apuracao: IApuracaoPonto | null): IApuracaoScope {
        if (!apuracao) {
            return this.createEmptyScope();
        }

        if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                tipo: 'trabalhador',
                empresa: this.entity.empresa,
                estabelecimento: apuracao.trabalhadorobj.estabelecimento || '',
                lotacao: null,
                trabalhador: {
                    trabalhador: apuracao.trabalhadorobj.trabalhador,
                    nome: apuracao.trabalhadorobj.nome || '',
                    codigo: apuracao.trabalhadorobj.codigo || '',
                },
                locks: {
                    estabelecimento: false,
                    lotacao: false,
                    trabalhadores: true,
                },
                forcaAbaTrabalhador: true,
            };
        }

        if (apuracao.lotacaoobj?.lotacao) {
            return {
                tipo: 'lotacao',
                empresa: this.entity.empresa,
                estabelecimento: apuracao.lotacaoobj.estabelecimento || '',
                lotacao: {
                    lotacao: apuracao.lotacaoobj.lotacao,
                    codigo: apuracao.lotacaoobj.codigo || '',
                    nome: apuracao.lotacaoobj.nome || '',
                    estabelecimento: apuracao.lotacaoobj.estabelecimento || '',
                },
                trabalhador: null,
                locks: {
                    estabelecimento: true,
                    lotacao: true,
                    trabalhadores: false,
                },
                forcaAbaTrabalhador: false,
            };
        }

        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                tipo: 'estabelecimento',
                empresa: apuracao.estabelecimentoobj.empresa || this.entity.empresa,
                estabelecimento: apuracao.estabelecimentoobj.estabelecimento,
                lotacao: null,
                trabalhador: null,
                locks: {
                    estabelecimento: true,
                    lotacao: false,
                    trabalhadores: false,
                },
                forcaAbaTrabalhador: false,
            };
        }

        if (apuracao.empresaobj?.empresa) {
            return {
                tipo: 'empresa',
                empresa: apuracao.empresaobj.empresa,
                estabelecimento: '',
                lotacao: null,
                trabalhador: null,
                locks: {
                    estabelecimento: false,
                    lotacao: false,
                    trabalhadores: false,
                },
                forcaAbaTrabalhador: false,
            };
        }

        return this.createEmptyScope();
    }

    resetFiltroState() {
        this.entity.estabelecimento = '';
        this.entity.departamento_colaboradores = null;
        this.entity.lotacao_colaboradores = null;
        this.entity.grupo_colaboradores = null;
        this.entity.estabelecimento_selecionado_ui = null;
        this.entity.departamento_colaboradores_selecionado_ui = null;
        this.entity.lotacao_colaboradores_selecionada_ui = null;
        this.entity.grupo_colaboradores_selecionado_ui = null;
        this.uiState.filtro.departamentoSelecionado = null;
        this.uiState.filtro.lotacaoSelecionada = null;
        this.uiState.filtro.grupoPontoSelecionado = null;
        this.uiState.locks.estabelecimento = false;
        this.uiState.locks.lotacao = false;
        this.uiState.sincronizacao.origemEstabelecimento = null;
    }

    resetTrabalhadorState() {
        this.uiState.trabalhador.selecionado = null;
        this.uiState.trabalhador.lista = [];
        this.uiState.locks.trabalhadores = false;
        this.uiState.tabs.disableFiltro = false;
        this.entity.trabalhadores = [];
        this.entity.trabalhador_selecionado_ui = null;
        this.entity.trabalhadores_selecionados_ui = [];
    }

    syncAllPayloads() {
        this.syncFiltroPayloadFromUi();
        this.syncTrabalhadoresPayloadFromUi();
    }

    refreshAllDependentSelects() {
        this.refreshFiltroSelects();
        this.refreshTrabalhadorSelect();
    }

    carregaEstabelecimentos() {
        this.estabelecimentos = this.entity.empresa
            ? this.ListagemService.montaEstabelecimentos(this.entity.empresa)
            : [];
    }

    // aba: selecao por filtro

    buildDepartamentoConstructors() {
        return this.buildEmpresaEstabelecimentoConstructors();
    }

    buildLotacaoConstructors() {
        return this.buildEmpresaEstabelecimentoConstructors();
    }

    buildGrupoPontoConstructors() {
        return {};
    }

    isEstabelecimentoSelectDisabled() {
        return this.uiState.locks.estabelecimento || !this.estabelecimentos.length;
    }

    isDepartamentoSelectDisabled() {
        return false;
    }

    isLotacaoSelectDisabled() {
        return this.uiState.locks.lotacao;
    }

    isFiltroTabDisabled() {
        return this.uiState.tabs.disableFiltro;
    }

    observeEstabelecimento() {
        this.$scope.$watch(
            () => this.entity?.estabelecimento,
            (newValue?: string, oldValue?: string) => {
                if (newValue === oldValue) {
                    return;
                }

                this.handleEstabelecimentoChange();
            },
        );
    }

    observeDepartamento() {
        this.$scope.$watch(
            () => this.uiState.filtro.departamentoSelecionado,
            () => {
                this.syncFiltroPayloadFromUi();
                this.syncEstabelecimentoFromDepartamento();
            },
            true,
        );
    }

    observeLotacao() {
        this.$scope.$watch(
            () => this.uiState.filtro.lotacaoSelecionada,
            () => {
                this.syncFiltroPayloadFromUi();
                this.syncEstabelecimentoFromLotacao();
            },
            true,
        );
    }

    observeGrupoPonto() {
        this.$scope.$watch(
            () => this.uiState.filtro.grupoPontoSelecionado,
            () => {
                this.syncFiltroPayloadFromUi();
            },
            true,
        );
    }

    handleEstabelecimentoChange() {
        this.resetDependentSelectionsFromEstabelecimentoChange(this.uiState.sincronizacao.origemEstabelecimento);
        this.uiState.sincronizacao.origemEstabelecimento = null;
        this.syncFiltroPayloadFromUi();
        this.refreshFiltroSelects();
    }

    resetDependentSelectionsFromEstabelecimentoChange(origem: OrigemSincronizacaoEstabelecimentoType) {
        if (origem === 'departamento') {
            if (!this.uiState.locks.lotacao) {
                this.uiState.filtro.lotacaoSelecionada = null;
            }
            return;
        }

        if (origem === 'lotacao') {
            this.uiState.filtro.departamentoSelecionado = null;
            return;
        }

        this.uiState.filtro.departamentoSelecionado = null;

        if (!this.uiState.locks.lotacao) {
            this.uiState.filtro.lotacaoSelecionada = null;
        }
    }

    syncEstabelecimentoFromDepartamento() {
        const estabelecimento = this.uiState.filtro.departamentoSelecionado?.estabelecimento;

        if (
            !estabelecimento ||
            this.uiState.locks.estabelecimento ||
            this.entity.estabelecimento === estabelecimento
        ) {
            return;
        }

        this.uiState.sincronizacao.origemEstabelecimento = 'departamento';
        this.entity.estabelecimento = estabelecimento;
    }

    syncEstabelecimentoFromLotacao() {
        const estabelecimento = this.uiState.filtro.lotacaoSelecionada?.estabelecimento;

        if (
            !estabelecimento ||
            this.uiState.locks.estabelecimento ||
            this.entity.estabelecimento === estabelecimento
        ) {
            return;
        }

        this.uiState.sincronizacao.origemEstabelecimento = 'lotacao';
        this.entity.estabelecimento = estabelecimento;
    }

    syncFiltroPayloadFromUi() {
        this.syncEstabelecimentoSelecionadoUi();
        this.entity.departamento_colaboradores = this.uiState.filtro.departamentoSelecionado?.departamento || null;
        this.entity.lotacao_colaboradores = this.uiState.filtro.lotacaoSelecionada?.lotacao || null;
        this.entity.grupo_colaboradores = this.uiState.filtro.grupoPontoSelecionado?.grupo || null;
        this.entity.departamento_colaboradores_selecionado_ui = this.uiState.filtro.departamentoSelecionado
            ? angular.copy(this.uiState.filtro.departamentoSelecionado)
            : null;
        this.entity.lotacao_colaboradores_selecionada_ui = this.uiState.filtro.lotacaoSelecionada
            ? angular.copy(this.uiState.filtro.lotacaoSelecionada)
            : null;
        this.entity.grupo_colaboradores_selecionado_ui = this.uiState.filtro.grupoPontoSelecionado
            ? angular.copy(this.uiState.filtro.grupoPontoSelecionado)
            : null;
    }

    refreshFiltroSelects() {
        this.$rootScope.$broadcast('departamentoColaboradores_refresh', this.buildDepartamentoConstructors());
        this.$rootScope.$broadcast('lotacaoColaboradores_refresh', this.buildLotacaoConstructors());
    }

    applyFiltroScope(scope: IApuracaoScope) {
        this.uiState.locks.estabelecimento = scope.locks.estabelecimento;
        this.uiState.locks.lotacao = scope.locks.lotacao;
        this.uiState.tabs.disableFiltro = scope.forcaAbaTrabalhador;

        if (scope.tipo === 'estabelecimento') {
            this.entity.estabelecimento = scope.estabelecimento;
            return;
        }

        if (scope.tipo === 'lotacao') {
            this.entity.estabelecimento = scope.estabelecimento;
            this.uiState.filtro.lotacaoSelecionada = scope.lotacao;
            return;
        }

        if (scope.tipo === 'trabalhador') {
            this.entity.estabelecimento = scope.estabelecimento;
        }
    }

    // aba: selecao por trabalhador

    buildTrabalhadorConstructors() {
        const constructor: any = {
            empresa: this.entity.empresa,
            estabelecimento: '',
        };

        if (!this.entity.apuracaoponto) {
            return constructor;
        }

        constructor.apuracaoponto = this.entity.apuracaoponto;

        if (this.apuracaoScope.estabelecimento) {
            constructor.estabelecimento = this.apuracaoScope.estabelecimento;
        }

        if (this.apuracaoScope.lotacao?.lotacao) {
            constructor.lotacao = this.apuracaoScope.lotacao.lotacao;
        }

        if (this.apuracaoScope.trabalhador?.trabalhador) {
            constructor.trabalhador = this.apuracaoScope.trabalhador.trabalhador;
        }

        return constructor;
    }

    isTrabalhadorSelectDisabled() {
        return this.uiState.locks.trabalhadores || !this.entity.empresa;
    }

    isTrabalhadorTabLocked() {
        return this.uiState.locks.trabalhadores;
    }

    observeTrabalhador() {
        this.$scope.$watch(
            () => this.uiState.trabalhador.selecionado,
            () => {
                if (!this.uiState.trabalhador.selecionado || this.uiState.locks.trabalhadores) {
                    return;
                }

                this.addTrabalhador(this.uiState.trabalhador.selecionado);

                this.$scope.$evalAsync(() => {
                    this.uiState.trabalhador.selecionado = null;
                    this.entity.trabalhador_selecionado_ui = null;
                });
            },
            true,
        );
    }

    addTrabalhador(trabalhador: IGeracaoDeMarcacoesPadraoTrabalhadorSelecionado) {
        const trabalhadorJaSelecionado = this.uiState.trabalhador.lista.some((item) => (
            item.trabalhador === trabalhador.trabalhador
        ));

        if (trabalhadorJaSelecionado) {
            return;
        }

        this.uiState.trabalhador.lista = [
            ...this.uiState.trabalhador.lista,
            {
                trabalhador: trabalhador.trabalhador,
                nome: trabalhador.nome,
                codigo: trabalhador.codigo,
            },
        ];

        this.syncTrabalhadoresPayloadFromUi();
    }

    onRemoveTrabalhador(trabalhadorRemovido: IGeracaoDeMarcacoesPadraoTrabalhadorSelecionado) {
        if (this.uiState.locks.trabalhadores) {
            return;
        }

        this.uiState.trabalhador.lista = this.uiState.trabalhador.lista.filter((trabalhador) => (
            trabalhador.trabalhador !== trabalhadorRemovido.trabalhador
        ));

        this.syncTrabalhadoresPayloadFromUi();
    }

    syncTrabalhadoresPayloadFromUi() {
        this.entity.trabalhadores = this.uiState.trabalhador.lista.map((trabalhador) => ({
            trabalhador: trabalhador.trabalhador,
        }));
        this.entity.trabalhadores_selecionados_ui = angular.copy(this.uiState.trabalhador.lista);
        this.entity.trabalhador_selecionado_ui = angular.copy(this.uiState.trabalhador.selecionado);
    }

    refreshTrabalhadorSelect() {
        if (!this.entity.apuracaoponto) {
            return;
        }

        this.$rootScope.$broadcast('trabalhadorColaboradores_refresh', this.buildTrabalhadorConstructors());
    }

    applyTrabalhadorScope(scope: IApuracaoScope) {
        this.uiState.locks.trabalhadores = scope.locks.trabalhadores;

        if (!scope.trabalhador) {
            return;
        }

        this.entity.aba_selecao_colaboradores = 2;
        this.uiState.trabalhador.lista = [scope.trabalhador];
    }

    // helpers compartilhados

    buildEmpresaEstabelecimentoConstructors() {
        return {
            empresa: this.entity.empresa,
            estabelecimento: this.entity.estabelecimento,
        };
    }

    syncEstabelecimentoSelecionadoUi() {
        if (!this.entity.estabelecimento) {
            this.entity.estabelecimento_selecionado_ui = null;
            return;
        }

        const estabelecimentoSelecionado = this.estabelecimentos.find((estabelecimento) => (
            estabelecimento.id === this.entity.estabelecimento
        ));

        this.entity.estabelecimento_selecionado_ui = estabelecimentoSelecionado ? {
            estabelecimento: estabelecimentoSelecionado.id,
            codigo: estabelecimentoSelecionado.codigo,
            nomefantasia: estabelecimentoSelecionado.nomefantasia,
        } : null;
    }
}
